var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPasswordChange = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "70px",
  height: "70px",
  viewBox: "0 0 70 70",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "ic_password_change") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_password_change",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "if_Tick_1737369",
  fill: "#63A813",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35,0.0603571429 C15.7330357,0.0603571429 0.0608928571,15.7346429 0.0608928571,35.0003571 C0.0608928571,54.2660714 15.7330357,69.9394643 35,69.9394643 C54.2657143,69.9394643 69.9389286,54.2660714 69.9389286,35.0003571 C69.9389286,15.7348214 54.2657143,0.0603571429 35,0.0603571429 Z M35,64.4282143 C18.7730357,64.4282143 5.57214286,51.22625 5.57214286,35.0003571 C5.57214286,18.7735714 18.7730357,5.57267857 35,5.57267857 C51.2269643,5.57267857 64.4278571,18.7735714 64.4278571,35.0003571 C64.4278571,51.22625 51.2269643,64.4282143 35,64.4282143 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.53875,20.4217857 L29.1516071,43.2310714 L18.0592857,35.19875 C16.6517857,34.1794643 14.6821429,34.4944643 13.6607143,35.9019643 C12.6414286,37.3116071 12.9564286,39.28 14.365,40.3005357 L27.6539286,49.9226786 C28.2085714,50.3246429 28.8555357,50.5208929 29.5005357,50.5208929 C30.3214286,50.5208929 31.1371429,50.2017857 31.7480357,49.5782143 L56.03375,24.8342857 C57.2525,23.5932143 57.2344643,21.5992857 55.9914286,20.3805357 C54.7525,19.1628571 52.7575,19.1808929 51.53875,20.4217857 Z",
  id: "Shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPasswordChange);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_password_change.30e16d2df803c156bb546f9e5f1e7040.svg";